import { Grid, IconButton, Tooltip } from '@mui/material'
import { useCallback, useContext, useEffect, useState } from 'react'
import { IoReload } from 'react-icons/io5'
import { MdAdd, MdArrowBack, MdDelete } from 'react-icons/md'
import { GlobalContext } from '../../../App'
import Programa from '../../../components/Programa/Programa'
import Table from '../../../components/Table/Table'
import { metodoPrograma } from '../../../components/api'
import { Edicao } from './Edicao'
// import Edicao from './Edicao';

export const TipoAgendamentoCRUD = () => {
  const { localAtendimento } = useContext(GlobalContext)

  const [lista, setLista] = useState([])
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)

  const getList = useCallback(() => {
    metodoPrograma('lista', { idLocalAtendimento: localAtendimento[0] }).then(
      (res) => {
        if (res.status) {
          setLista(res.lista)
        }
      },
    )
  }, [localAtendimento])

  const voltar = () => {
    setTela('lista')
    setDados(undefined)
    getList()
  }

  const exclui = (idTipoAgendamento) => async (e) => {
    e.stopPropagation()
    if (
      !window.confirm(
        'Mas você tem CERTEZA que deseja excluir este local de Atendimento???',
      )
    )
      return
    await metodoPrograma('exclui', { idTipoAgendamento })
    await getList()
  }

  const handleClick = (linha) => {
    setDados(linha)
    setTela('opcoes')
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  useEffect(() => {
    if (localAtendimento) {
      getList()
    }
  }, [localAtendimento, getList])

  return (
    <Programa codigo="CtrlTipoDeAgendamento" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Table
              dados={lista}
              head={['Atendimento', '', '']}
              line={(item) => [item[2], item[3], '']}
              columnOptions={[
                {
                  alias: 2,
                  customJsx: ({ linhaOriginal }) => (
                    <IconButton size="small" onClick={exclui(linhaOriginal[0])}>
                      {linhaOriginal[3] ? <IoReload /> : <MdDelete />}
                    </IconButton>
                  ),
                },
              ]}
              onClick={(e, linhaOriginal) => handleClick(linhaOriginal)}
            />
          </Grid>
        </Grid>
      ) : (
        <Edicao {...{ dados, voltar }} />
      )}
    </Programa>
  )
}
